import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      'language.name': 'English',
      'language.english': 'English',
      'language.norwegian': 'Norwegian',
      'search.placeholder': 'Search for Patients',
      'top.adminPanel': 'Admin Panel',
      'top.account': 'Account',
      'top.myProfile': 'My Profile',
      'top.settings': 'Settings',
      'top.logout': 'Log out',
      'top.user': 'User',
      'btn.back': 'Back',
      'users.title': 'User Management',
      'users.subtitle': 'Manage demo users and their accounts',
      'users.create': 'Create User',
      'table.user': 'User',
      'table.email': 'Email',
      'table.role': 'Role',
      'table.status': 'Status',
      'table.created': 'Created',
      'table.actions': 'Actions',
      'loading': 'Loading...',
      'no.users': 'No users found',
      'chip.admin': 'Admin',
      'chip.demo': 'Demo',
      'chip.active': 'Active',
      'chip.inactive': 'Inactive',
      'dialog.createUser.title': 'Create New Demo User',
      'dialog.cancel': 'Cancel',
      'dialog.create': 'Create',
      'confirm.deleteUser': 'Are you sure you want to delete this user?',
      'login.title': 'Sign In',
      'login.subtitle': 'Welcome to the RPM Demo Dashboard',
      'login.email': 'Email',
      'login.password': 'Password',
      'login.signingIn': 'Signing in...',
      'login.signIn': 'Sign In',
      'login.failed': 'Login failed. Please check your credentials.',
      'settings.title': 'Settings',
      'settings.subtitle': 'Manage your account preferences and settings',
      'settings.admin': 'Admin',
      'settings.environment': 'Environment',
      'settings.openEmrCredentials': 'OpenEMR Credentials',
      'settings.clientId': 'Client ID',
      'settings.clientSecret': 'Client Secret',
      'settings.accountSettings': 'Account Settings',
      'settings.emailAddress': 'Email Address',
      'settings.update': 'Update',
      'settings.password': 'Password',
      'settings.comingSoon': 'Coming soon',
      'settings.change': 'Change',
      'settings.notifications': 'Notifications',
      'settings.emailNotifications': 'Email Notifications',
      'settings.pushNotifications': 'Push Notifications',
      'settings.receiveUpdates': 'Receive updates and alerts via email',
      'settings.receivePush': 'Receive browser push notifications',
      'settings.preferences': 'Preferences',
      'settings.language': 'Language',
      'settings.timeZone': 'Time Zone',
      'settings.dangerZone': 'Danger Zone',
      'settings.deleteWarning': 'Once you delete your account, there is no going back. Please be certain.',
      'settings.deleteAccount': 'Delete Account',
      'settings.changePassword': 'Change Password',
      'settings.changePasswordDesc': 'Enter your current password and choose a new password for your account.',
      'settings.currentPassword': 'Current Password',
      'settings.newPassword': 'New Password',
      'settings.confirmPassword': 'Confirm New Password',
      'settings.passwordChanged': 'Password changed successfully!',
      'settings.languageChangeFailed': 'Failed to change language. Please try again.',
      'dashboard.title': 'Patients',
      'dashboard.subtitle': 'Click on a patient row to view details',
      'dashboard.alert': 'Alert',
      'dashboard.lastReading': 'Last reading',
      'dashboard.patient': 'Patient',
      'dashboard.age': 'Age',
      'dashboard.gender': 'Gender',
      'dashboard.location': 'Location',
      'dashboard.status': 'Status',
      'dashboard.actions': 'Actions',
      'dashboard.viewPatient': 'View patient',
      'dashboard.noAlerts': 'No alerts',
      'dashboard.adminAccessDenied': 'Admin panel access requires superuser privileges.',
      'chat.placeholder': 'How can I help you today?',
      'chat.readOnlyPlaceholder': 'This conversation was shared with you — view only',
      'chat.sharedBy': 'Shared by {{name}}',
      'chat.anotherUser': 'another user',
      'chat.viewOnly': 'View only',
      'chat.thinking': 'Thinking...',
      'chat.thinkingSynonyms': [
        'Thinking...',
        'Pondering...',
        'Evaluating...',
        'Reasoning...',
        'Considering...',
        'Analyzing...',
        'Reflecting...',
        'Weighing the options...',
        'Processing...',
        'Mulling it over...',
      ],
      'chat.summarizing': 'Compacting Conversation...',
      'chat.recallingMemory': 'Recalling from memory...',
      'chat.memory.pill': '{{count}} from memory',
      'chat.memory.dialogTitle': 'Recalled from memory',
      'chat.memory.dialogSubtitle': 'Facts recalled from earlier conversations for this answer, each shown with the original message it came from.',
      'chat.memory.validSince': 'Since {{date}}',
      'chat.memory.sourceFrom': 'From {{date}}',
      'chat.memory.unknownDate': 'an earlier conversation',
      'chat.memory.noSource': 'Original source unavailable.',
      'sidebar.backToPatients': 'Back to all patients',
      'sidebar.newChat': 'New chat',
      'sidebar.yourChats': 'Your Chats',
      'sidebar.yourArchives': 'Your Archives',
      'sidebar.noChatsYet': 'No chats yet. Start a new conversation.',
      'sidebar.noArchivedYet': 'No archived chats yet.',
      'sidebar.conversation': 'Conversation',
      'sidebar.searchChats': 'Search Chats',
      'sidebar.searchPlaceholder': 'Search conversations...',
      'sidebar.noResultsFound': 'No conversations found.',
      'sidebar.archive': 'Archive',
      'sidebar.unarchive': 'Unarchive',
      'sidebar.delete': 'Delete',
      'sidebar.rename': 'Rename',
      'sidebar.renamePlaceholder': 'Conversation name...',
      'profile.admin': 'Admin',
      'profile.demo': 'Demo',
      'profile.account': 'Account',
      'profile.aiDemoLogs': 'AI Demo Logs',
      'patient.id': 'Patient ID',
      'patient.gender': 'Gender',
      'patient.age': 'Age',
      'patient.weight': 'Weight',
      'patient.height': 'Height',
      'date.today': 'Today',
      'date.yesterday': 'Yesterday',
      'date.daysAgo': '{{days}} days ago',
      
      'status.open': 'Open',
      'tab.vitals': 'Vitals',
      'tab.memory': 'Memory',
      'facts.title': 'Recorded Conditions & Allergies',
      'facts.filter.all': 'All',
      'facts.filter.active': 'Active',
      'facts.filter.invalid': 'Invalidated',
      'facts.empty': 'No facts recorded for this patient yet.',
      'facts.emptyFiltered': 'No facts match this filter.',
      'facts.loadError': 'Could not load facts.',
      'facts.add': 'Add',
      'facts.addTitle': 'Add a fact',
      'facts.addPlaceholder': 'e.g. The patient is allergic to penicillin.',
      'facts.addHint': 'New facts are extracted in the background and may take a moment to appear.',
      'facts.adding': 'Adding — extracting facts in the background. This can take up to a minute.',
      'facts.addTimeout': 'The new entry is taking longer than expected. It may still appear — try refreshing the list.',
      'facts.addSubmit': 'Add',
      'facts.retry': 'Retry',
      'facts.cancel': 'Cancel',
      'facts.save': 'Save',
      'facts.edit': 'Edit',
      'facts.invalidated': 'Invalidated',
      'facts.source': 'Source',
      'facts.sourceEmpty': 'No source recorded.',
      'facts.action.invalidate': 'Invalidate',
      'facts.action.restore': 'Restore',
      'facts.action.delete': 'Delete permanently',
      'facts.invalidateTitle': 'Invalidate this fact?',
      'facts.invalidateBody': 'It will be hidden from the assistant but kept on the record and can be restored later.',
      'facts.invalidateConfirm': 'Invalidate',
      'facts.deleteTitle': 'Delete this fact permanently?',
      'facts.deleteBody': 'This removes the fact from the graph entirely. It cannot be undone.',
      'facts.deleteConfirm': 'Delete',
      'facts.actionError': 'Something went wrong. Please try again.',
      'facts.note': 'Manual edits can still be superseded by future conversations.',
      'vitals.systolicBP': 'Systolic BP',
      'vitals.diastolicBP': 'Diastolic BP',
      'vitals.heartRate': 'Heart Rate',
      'vitals.spo2': 'SpO₂',
      'vitals.forecast': 'Forecast',
      'vitals.high': 'HIGH',
      'vitals.low': 'LOW',
      'vitals.noData': 'No vitals data available.',
      'vitals.critical': 'Critical',
      'vitals.warning': 'Warning',
      'vitals.thresholdsTitle': 'Vital Thresholds',
      'vitals.thresholdsTable.vital': 'Vital',
      'vitals.thresholdsTable.type': 'Type',
      'vitals.thresholdsTable.level': 'Level',
      'vitals.thresholdsTable.value': 'Value',
      'translation.loading': 'Translating...',
      'copilot.ranAt': 'Ran at',
      'copilot.runId': 'Run ID',
      'copilot.model.pestle.description': 'Medical model (Pestle-27B). Strong clinical reasoning with fast, efficient responses.',
      'copilot.model.qwen.description': 'Strong general reasoning and instruction-following. Best for summarisation, structured output, and fast responses.',
      'copilot.summaryLoading': 'Loading Patient Summary',
      'runs.allRuns': 'All runs',
      'runs.allModelRuns': 'All model runs',
      'runs.total': 'total',
      'runs.vitalsAt': 'Vitals At:',
      'runs.selectDate': 'Select date',
      'runs.seeMoreDates': 'See more dates',
      'runs.latest': 'Latest',
      'runs.numberSymbol': '#',
      'runs.date': 'Date',
      'runs.tftModel': 'TFT Model',
      'runs.copilotModel': 'Copilot Model',
      'runs.status': 'Status',
      'theme.name': 'Theme',
      'theme.light': 'Light',
      'theme.dark': 'Dark',
      'theme.system': 'System',
      'nav.guidelines': 'Guidelines',
      'guidelines.title': 'Guidelines',
      'guidelines.loading': 'Loading guidelines...',
      'guidelines.error': 'Failed to load guidelines.',
      'guidelines.empty': 'No guidelines assigned to your organisation yet.',
      'guidelines.col.title': 'Title',
      'guidelines.col.description': 'Description',
      'guidelines.col.source': 'Source',
      'guidelines.col.lang': 'Lang',
      'guidelines.open': 'Open guideline',
      'guidelines.count_one': '{{count}} guideline',
      'guidelines.count_other': '{{count}} guidelines',
      'share.button': 'Share',
      'share.options': 'Share options',
      'share.title': 'Share conversation',
      'share.close': 'Close',
      'share.done': 'Done',
      'share.linkSection': 'Share link',
      'share.linkHelp': 'Anyone with the link who is signed in can view this conversation.',
      'share.copyLink': 'Copy link',
      'share.linkCopied': 'Link copied to clipboard.',
      'share.copyError': 'Could not copy the link.',
      'share.addPeople': 'Add people',
      'share.emailPlaceholder': 'Enter an email address',
      'share.add': 'Add',
      'share.noPeople': 'Not shared with anyone yet.',
      'share.remove': 'Remove',
      'share.readOnly': 'Read only',
      'share.userAdded': 'Access granted.',
      'share.userNotFound': 'No user found with that email.',
      'share.alreadyShared': 'Already shared with this user.',
      'share.addError': 'Could not share with this user.',
      'share.revokeError': 'Could not remove access.',
      'share.loadError': 'Could not load sharing settings.',
      'share.sharedWithMe': 'Shared with me',
      'share.sharedConversation': 'Shared conversation',
      'share.unavailable': 'This shared conversation is no longer available.',
      'share.backToDashboard': 'Back to dashboard',
      'share.dialogTitle': 'Share "{{title}}"',
      'share.notifyUser': 'Notify user',
      'share.notePlaceholder': 'Add a note',
      'share.peopleWithAccess': 'People with access',
      'share.generalAccess': 'General access',
      'share.restricted': 'Restricted',
      'share.anyoneWithLink': 'Anyone with the link',
      'share.anyoneCanView': 'Any signed-in person with the link can view.',
      'share.onlyAddedCanView': 'Only users added here can view.',
      'share.removePerson': 'Remove {{email}}',
      'share.invalidEmail': 'Enter a valid email address.',
      'share.alreadyHasAccess': '{{email}} already has access.',
      'share.personAdded': 'Person added.',
      'share.peopleAdded': '{{count}} people added.',
      'share.send': 'Send',
      'share.sending': 'Sending…',
      'share.updateError': 'Could not update sharing.',
      'share.modeError': 'Could not change access.',
    },
  },
  no: {
    translation: {
      'language.name': 'Norsk',
      'language.english': 'Engelsk',
      'language.norwegian': 'Norsk',
      'search.placeholder': 'Søk etter pasienter',
      'top.adminPanel': 'Administrasjonspanel',
      'top.account': 'Konto',
      'top.myProfile': 'Min profil',
      'top.settings': 'Innstillinger',
      'top.logout': 'Logg ut',
      'top.user': 'Bruker',
      'btn.back': 'Tilbake',
      'users.title': 'Brukeradministrasjon',
      'users.subtitle': 'Administrer demobrukere og deres kontoer',
      'users.create': 'Opprett bruker',
      'table.user': 'Bruker',
      'table.email': 'E-post',
      'table.role': 'Rolle',
      'table.status': 'Status',
      'table.created': 'Opprettet',
      'table.actions': 'Handlinger',
      'loading': 'Laster...',
      'no.users': 'Ingen brukere funnet',
      'chip.admin': 'Administrator',
      'chip.demo': 'Demo',
      'chip.active': 'Aktiv',
      'chip.inactive': 'Inaktiv',
      'dialog.createUser.title': 'Opprett ny demobruker',
      'dialog.cancel': 'Avbryt',
      'dialog.create': 'Opprett',
      'confirm.deleteUser': 'Er du sikker på at du vil slette denne brukeren?',
      'login.title': 'Logg inn',
      'login.subtitle': 'Velkommen til RPM Demo Dashboard',
      'login.email': 'E-post',
      'login.password': 'Passord',
      'login.signingIn': 'Logger inn...',
      'login.signIn': 'Logg inn',
      'login.failed': 'Innlogging mislyktes. Vennligst sjekk legitimasjonen din.',
      'settings.title': 'Innstillinger',
      'settings.subtitle': 'Administrer dine kontopreferanser og innstillinger',
      'settings.admin': 'Admin',
      'settings.environment': 'Miljø',
      'settings.openEmrCredentials': 'OpenEMR-legitimasjon',
      'settings.clientId': 'Klient-ID',
      'settings.clientSecret': 'Klienthemmelighet',
      'settings.accountSettings': 'Kontoinnstillinger',
      'settings.emailAddress': 'E-postadresse',
      'settings.update': 'Oppdater',
      'settings.password': 'Passord',
      'settings.comingSoon': 'Kommer snart',
      'settings.change': 'Endre',
      'settings.notifications': 'Varsler',
      'settings.emailNotifications': 'E-postvarsler',
      'settings.pushNotifications': 'Push-varsler',
      'settings.receiveUpdates': 'Motta oppdateringer og varsler via e-post',
      'settings.receivePush': 'Motta nettleser push-varsler',
      'settings.preferences': 'Preferanser',
      'settings.language': 'Språk',
      'settings.timeZone': 'Tidssone',
      'settings.dangerZone': 'Faresone',
      'settings.deleteWarning': 'Når du sletter kontoen din, er det ingen vei tilbake. Vær sikker.',
      'settings.deleteAccount': 'Slett konto',
      'settings.changePassword': 'Endre passord',
      'settings.changePasswordDesc': 'Skriv inn ditt nåværende passord og velg et nytt passord for kontoen din.',
      'settings.currentPassword': 'Nåværende passord',
      'settings.newPassword': 'Nytt passord',
      'settings.confirmPassword': 'Bekreft nytt passord',
      'settings.passwordChanged': 'Passord endret!',
      'settings.languageChangeFailed': 'Kunne ikke endre språk. Prøv igjen.',
      'dashboard.title': 'Pasienter',
      'dashboard.subtitle': 'Klikk på en pasientrad for å se detaljer',
      'dashboard.alert': 'Varsel',
      'dashboard.lastReading': 'Siste avlesning',
      'dashboard.patient': 'Pasient',
      'dashboard.age': 'Alder',
      'dashboard.gender': 'Kjønn',
      'dashboard.location': 'Sted',
      'dashboard.status': 'Status',
      'dashboard.actions': 'Handlinger',
      'dashboard.viewPatient': 'Vis pasient',
      'dashboard.noAlerts': 'Ingen varsler',
      'dashboard.adminAccessDenied': 'Tilgang til administrasjonspanelet krever superbrukerrettigheter.',
      'chat.placeholder': 'Still meg et oppfølgingsspørsmål',
      'chat.readOnlyPlaceholder': 'Denne samtalen ble delt med deg — kun visning',
      'chat.sharedBy': 'Delt av {{name}}',
      'chat.anotherUser': 'en annen bruker',
      'chat.viewOnly': 'Kun visning',
      'chat.thinking': 'Tenker...',
      'chat.thinkingSynonyms': [
        'Tenker...',
        'Grubler...',
        'Vurderer...',
        'Resonnerer...',
        'Overveier...',
        'Analyserer...',
        'Reflekterer...',
        'Veier alternativene...',
        'Bearbeider...',
        'Tenker seg om...',
      ],
      'chat.summarizing': 'Oppsummerer samtalesammenheng',
      'chat.recallingMemory': 'Henter fra hukommelse...',
      'chat.memory.pill': '{{count}} fra hukommelse',
      'chat.memory.dialogTitle': 'Hentet fra hukommelse',
      'chat.memory.dialogSubtitle': 'Fakta hentet fra tidligere samtaler for dette svaret, hver vist med den opprinnelige meldingen det kom fra.',
      'chat.memory.validSince': 'Siden {{date}}',
      'chat.memory.sourceFrom': 'Fra {{date}}',
      'chat.memory.unknownDate': 'en tidligere samtale',
      'chat.memory.noSource': 'Opprinnelig kilde utilgjengelig.',
      'sidebar.backToPatients': 'Tilbake til alle pasienter',
      'sidebar.newChat': 'Ny samtale',
      'sidebar.yourChats': 'Dine samtaler',
      'sidebar.yourArchives': 'Dine arkiver',
      'sidebar.noChatsYet': 'Ingen samtaler ennå. Start en ny samtale.',
      'sidebar.noArchivedYet': 'Ingen arkiverte samtaler ennå.',
      'sidebar.conversation': 'Samtale',
      'sidebar.searchChats': 'Søk i samtaler',
      'sidebar.searchPlaceholder': 'Søk i samtaler...',
      'sidebar.noResultsFound': 'Ingen samtaler funnet.',
      'sidebar.archive': 'Arkiver',
      'sidebar.unarchive': 'Gjenopprett',
      'sidebar.delete': 'Slett',
      'sidebar.rename': 'Gi nytt navn',
      'sidebar.renamePlaceholder': 'Samtalenavn...',
      'profile.admin': 'Admin',
      'profile.demo': 'Demo',
      'profile.account': 'Konto',
      'profile.aiDemoLogs': 'AI Demo-logger',
      'patient.id': 'Pasient-ID',
      'patient.gender': 'Kjønn',
      'patient.age': 'Alder',
      'patient.weight': 'Vekt',
      'patient.height': 'Høyde',
      'date.today': 'I dag',
      'date.yesterday': 'I går',
      'date.daysAgo': '{{days}} dager siden',
      
      'status.open': 'Åpne',
      'tab.vitals': 'Vitale tegn',
      'tab.memory': 'Minne',
      'facts.title': 'Registrerte tilstander og allergier',
      'facts.filter.all': 'Alle',
      'facts.filter.active': 'Aktive',
      'facts.filter.invalid': 'Ugyldiggjort',
      'facts.empty': 'Ingen fakta registrert for denne pasienten ennå.',
      'facts.emptyFiltered': 'Ingen fakta samsvarer med dette filteret.',
      'facts.loadError': 'Kunne ikke laste fakta.',
      'facts.add': 'Legg til',
      'facts.addTitle': 'Legg til et faktum',
      'facts.addPlaceholder': 'f.eks. Pasienten er allergisk mot penicillin.',
      'facts.addHint': 'Nye fakta hentes ut i bakgrunnen og kan ta et øyeblikk før de vises.',
      'facts.adding': 'Legger til — henter ut fakta i bakgrunnen. Dette kan ta opptil ett minutt.',
      'facts.addTimeout': 'Den nye oppføringen tar lenger tid enn forventet. Den kan fortsatt dukke opp — prøv å oppdatere listen.',
      'facts.addSubmit': 'Legg til',
      'facts.retry': 'Prøv igjen',
      'facts.cancel': 'Avbryt',
      'facts.save': 'Lagre',
      'facts.edit': 'Rediger',
      'facts.invalidated': 'Ugyldiggjort',
      'facts.source': 'Kilde',
      'facts.sourceEmpty': 'Ingen kilde registrert.',
      'facts.action.invalidate': 'Ugyldiggjør',
      'facts.action.restore': 'Gjenopprett',
      'facts.action.delete': 'Slett permanent',
      'facts.invalidateTitle': 'Ugyldiggjøre dette faktumet?',
      'facts.invalidateBody': 'Det skjules fra assistenten, men beholdes i journalen og kan gjenopprettes senere.',
      'facts.invalidateConfirm': 'Ugyldiggjør',
      'facts.deleteTitle': 'Slette dette faktumet permanent?',
      'facts.deleteBody': 'Dette fjerner faktumet fra grafen fullstendig. Det kan ikke angres.',
      'facts.deleteConfirm': 'Slett',
      'facts.actionError': 'Noe gikk galt. Prøv igjen.',
      'facts.note': 'Manuelle endringer kan fortsatt overstyres av fremtidige samtaler.',
      'vitals.systolicBP': 'Systolisk BT',
      'vitals.diastolicBP': 'Diastolisk BT',
      'vitals.heartRate': 'Puls',
      'vitals.spo2': 'SpO₂',
      'vitals.forecast': 'Prognose',
      'vitals.high': 'HØY',
      'vitals.low': 'LAV',
      'vitals.noData': 'Ingen vitale data tilgjengelig.',
      'vitals.critical': 'Kritisk',
      'vitals.warning': 'Advarsel',
      'vitals.thresholdsTitle': 'Terskelverdier for vitale tegn',
      'vitals.thresholdsTable.vital': 'Vital',
      'vitals.thresholdsTable.type': 'Type',
      'vitals.thresholdsTable.level': 'Nivå',
      'vitals.thresholdsTable.value': 'Verdi',
      'translation.loading': 'Oversetter...',
      'copilot.ranAt': 'Kjørt',
      'copilot.runId': 'Kjøring-ID',
      'copilot.model.pestle.description': 'Medisinsk modell (Pestle-27B). Sterk klinisk resonnering med raske, effektive svar.',
      'copilot.model.qwen.description': 'Sterk generell resonnering og instruksjonsfølging. Best egnet for oppsummering, strukturert utdata og raske svar.',
      'copilot.summaryLoading': 'Laster pasientsammendrag',
      'runs.allRuns': 'Alle kjøringer',
      'runs.allModelRuns': 'Alle modellkjøringer',
      'runs.total': 'totalt',
      'runs.vitalsAt': 'Vitaler fra:',
      'runs.selectDate': 'Velg dato',
      'runs.seeMoreDates': 'Se flere datoer',
      'runs.latest': 'Nyeste',
      'runs.numberSymbol': '#',
      'runs.date': 'Dato',
      'runs.tftModel': 'TFT-modell',
      'runs.copilotModel': 'Copilot-modell',
      'runs.status': 'Status',
      'theme.name': 'Tema',
      'theme.light': 'Lyst',
      'theme.dark': 'Mørkt',
      'theme.system': 'System',
      'nav.guidelines': 'Retningslinjer',
      'guidelines.title': 'Retningslinjer',
      'guidelines.loading': 'Laster retningslinjer...',
      'guidelines.error': 'Kunne ikke laste retningslinjer.',
      'guidelines.empty': 'Ingen retningslinjer er tilordnet organisasjonen din ennå.',
      'guidelines.col.title': 'Tittel',
      'guidelines.col.description': 'Beskrivelse',
      'guidelines.col.source': 'Kilde',
      'guidelines.col.lang': 'Språk',
      'guidelines.open': 'Åpne retningslinje',
      'guidelines.count_one': '{{count}} retningslinje',
      'guidelines.count_other': '{{count}} retningslinjer',
      'share.button': 'Del',
      'share.options': 'Delingsalternativer',
      'share.title': 'Del samtale',
      'share.close': 'Lukk',
      'share.done': 'Ferdig',
      'share.linkSection': 'Delingslenke',
      'share.linkHelp': 'Alle med lenken som er innlogget kan se denne samtalen.',
      'share.copyLink': 'Kopier lenke',
      'share.linkCopied': 'Lenke kopiert til utklippstavlen.',
      'share.copyError': 'Kunne ikke kopiere lenken.',
      'share.addPeople': 'Legg til personer',
      'share.emailPlaceholder': 'Skriv inn en e-postadresse',
      'share.add': 'Legg til',
      'share.noPeople': 'Ikke delt med noen ennå.',
      'share.remove': 'Fjern',
      'share.readOnly': 'Skrivebeskyttet',
      'share.userAdded': 'Tilgang gitt.',
      'share.userNotFound': 'Fant ingen bruker med den e-posten.',
      'share.alreadyShared': 'Allerede delt med denne brukeren.',
      'share.addError': 'Kunne ikke dele med denne brukeren.',
      'share.revokeError': 'Kunne ikke fjerne tilgang.',
      'share.loadError': 'Kunne ikke laste delingsinnstillinger.',
      'share.sharedWithMe': 'Delt med meg',
      'share.sharedConversation': 'Delt samtale',
      'share.unavailable': 'Denne delte samtalen er ikke lenger tilgjengelig.',
      'share.backToDashboard': 'Tilbake til oversikten',
      'share.dialogTitle': 'Del "{{title}}"',
      'share.notifyUser': 'Varsle bruker',
      'share.notePlaceholder': 'Legg til en merknad',
      'share.peopleWithAccess': 'Personer med tilgang',
      'share.generalAccess': 'Generell tilgang',
      'share.restricted': 'Begrenset',
      'share.anyoneWithLink': 'Alle med lenken',
      'share.anyoneCanView': 'Enhver innlogget person med lenken kan se samtalen.',
      'share.onlyAddedCanView': 'Bare brukere som legges til her kan se samtalen.',
      'share.removePerson': 'Fjern {{email}}',
      'share.invalidEmail': 'Skriv inn en gyldig e-postadresse.',
      'share.alreadyHasAccess': '{{email}} har allerede tilgang.',
      'share.personAdded': 'Person lagt til.',
      'share.peopleAdded': '{{count}} personer lagt til.',
      'share.send': 'Send',
      'share.sending': 'Sender…',
      'share.updateError': 'Kunne ikke oppdatere deling.',
      'share.modeError': 'Kunne ikke endre tilgang.',
    },
  },
};

try {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: 'en',
      supportedLngs: ['en', 'no'],
      detection: {
        order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
        lookupLocalStorage: 'app_language',
        caches: ['localStorage'],
      },
      interpolation: { escapeValue: false },
    });
} catch (err) {
  console.warn('i18n initialization failed, falling back to en:', err);
  i18n.use(initReactI18next).init({ resources, lng: 'en', fallbackLng: 'en', interpolation: { escapeValue: false } });
}

export default i18n;
